<!-- LOADING -->
<div *ngIf="isLoading" style="text-align:center; padding:30px;">
  <p>Loading...</p>
</div>

<!-- RECEIPTS LIST -->
<ng-container *ngIf="!isLoading">

  <div *ngFor="let order of booksByOrder; let i = index" style="border:2px solid black; margin:15px; padding:12px;">

    <div style="display:flex;">

      <!-- LEFT -->
      <div style="width:50%; border-right:1px dashed black; padding-right:12px;">

        <div><b>बुक सेलर :</b> {{ order.books[0]?.custname || '-' }}</div>
        <div><b>प्रतिनिधी :</b> {{ order.books[0]?.rep || '-' }}</div>

        <div style="display:flex; justify-content:space-between;">
          <div><b>ऑर्डर नं :</b> {{ order.order_no || '-' }}</div>
          <div><b>दिनांक :</b> {{ order.books[0]?.bookingdate | date:'dd-MM-yyyy' }}</div>
        </div>

        <div style="display:flex; justify-content:space-between;">
          <div><b>बिल नं :</b> {{ order.books[0]?.invoice_no || '-' }}</div>
          <div><b>बिल दिनांक :</b> {{ order.books[0]?.invoice_date | date:'dd-MM-yyyy' }}</div>
        </div>

        <div style="display:flex; justify-content:space-between;">
          <div><b>पावती नं :</b> {{ order.books[0]?.rcptno || '-' }}</div>
          <div><b>पावती दिनांक :</b> {{ order.books[0]?.rcptdate | date:'dd-MM-yyyy' }}</div>
        </div>

        <!-- BOOK LIST -->
        <div style="display:flex; font-weight:bold; margin-top:10px;">
          <div style="width:70%;">पुस्तक</div>
          <div style="width:30%;">प्रती</div>
        </div>

        <div *ngFor="let item of order.booksData; let j = index" style="display:flex;">
          <div style="width:70%;">{{ j + 1 }}) {{ item.bookname }}</div>
          <div style="width:30%;">{{ item.bookcopies }}</div>
        </div>

        <!-- COURIER PER ORDER -->
        <div class="noPrint" style="margin: 10px 0; display:flex; gap:10px; align-items:center;">
          <input class="courier-input" placeholder="Courier Name" [(ngModel)]="order.couriername"
            (ngModelChange)="saveCourierPerOrder(order)" />
          <input class="courier-input" type="date" [(ngModel)]="order.courierdate"
            (ngModelChange)="saveCourierPerOrder(order)" />
        </div>

      </div>

      <!-- RIGHT -->
      <div style="width:50%; padding-left:12px;">

        <div style="text-align:right; font-weight:bold;">
          {{ order.books[0]?.deliverymode || 'By Hand' }}
        </div>

        <div><b>प्रति,</b></div>
        <div><b>बुक सेलर :</b> {{ order.books[0]?.custname }}</div>
        <div><b>पत्ता :</b> {{ order.books[0]?.address1 }}</div>
        <div><b>मोबाईल :</b> {{ order.books[0]?.mobile_no }}</div>

        <div style="display:flex; margin-top:20px;">
          <div style="width:40%;">
            <img src="../../../assets/img/brand/book.png" style="width:80%;" alt="logo">
          </div>
          <div style="width:60%; font-size:13px;">
            <b>प्रेषक,</b><br>
            हिंदुस्थान प्रकाशन संस्था - पुस्तक विभाग,<br>
            116-119,पहिला मजला, शिल्पीन सेंटर, 40, गं. द. आंबेकर मार्ग,<br>
             वडाला मुंबई - 400031<br>
            दूरध्वनी: ९९६७५७०५३१
          </div>
        </div>

        <!-- ✅ MOVED INSIDE THE LOOP — order is valid here -->
        <div class="noPrint" style="margin-top:16px; text-align:right; display:flex; gap:8px; justify-content:flex-end;">
          <button mat-raised-button color="primary"
                  [disabled]="sendingWhatsApp[order?.order_no] || whatsAppSent[order?.order_no]"
                  (click)="sendWhatsApp(order)">
            <span *ngIf="!sendingWhatsApp[order?.order_no] && !whatsAppSent[order?.order_no]">WhatsApp पाठवा</span>
            <span *ngIf="sendingWhatsApp[order?.order_no]">पाठवत आहे...</span>
            <span *ngIf="whatsAppSent[order?.order_no]">✔ पाठवले</span>
          </button>

          <button mat-raised-button color="warn" (click)="markDone(order)">
            ✔ Done
          </button>
        </div>

      </div>
    </div>
  </div>

  <div class="done-msg" *ngIf="booksByOrder.length === 0">
    ✔ Done! सर्व काम पूर्ण झाले आहे.
  </div>


  <!-- BUTTONS -->
  <div class="noPrint btns">
    <button mat-raised-button color="accent" (click)="print()">Print</button>
    <button mat-raised-button color="primary" (click)="markAllDone()">✔ Mark All Done</button>
    <button mat-button (click)="closeDialog()">Close</button>
    <button mat-raised-button color="primary"
        [disabled]="sendingAllWhatsApp || !booksByOrder.length"
        (click)="sendAllWhatsApp()">
  {{ sendingAllWhatsApp ? 'पाठवत आहे...' : 'सर्व WhatsApp पाठवा' }}
</button>
  </div>

</ng-container>